import { X } from "lucide-react";

const DeleteRole = ({ onClose }) => {
  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[30%] bg-white">
          {/* Header */}
          <div className="flex items-center justify-end p-6 text-black ">
            {/* <div>
              <h2 className="text-lg lg:text-xl font-popinsSemiBold">Edit Role</h2>
            </div> */}
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div>
            <p className="font-popinsSemiBold text-xl w-[90%] mx-auto text-center">
              Are you sure do you want to delete this role?
            </p>
            <div className="flex justify-end w-[90%] mx-auto gap-x-3 mb-5">
              <button
                type="submit"
                className="relative overflow-hidden py-3 px-12 bg-[#F0F2F5] text-black font-popinsSemiBold text-sm mt-8 rounded-md shadow-lg
           transform transition duration-300 ease-in-out
           hover:bg-[#F0F2F5]/90 hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
           active:scale-95 active:shadow-inner focus:outline-none
           disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
           onClick={onClose}
              >
                No
                <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
              </button>
              <button
                type="submit"
                className="relative overflow-hidden py-3 px-12 bg-themeColor text-black font-popinsSemiBold text-sm mt-8 rounded-md shadow-lg
           transform transition duration-300 ease-in-out
           hover:bg-themeColor/90 hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
           active:scale-95 active:shadow-inner focus:outline-none
           disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
              >
                Yes
                <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteRole;
